import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import './NewArrivals.css';
import { useNavigate } from "react-router-dom";

const NewArrivals = () => {
    const [country, setCountry] = useState('Loading...');
    const [cars, setCars] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        // Fetch car details
        fetch('https://skcapi.btcjapan.co/get-car-details.php')
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                //console.log("Fetched car data:", data);
                setCars(data);
            })
            .catch(error => {
                console.error("Error fetching car details:", error);
            });
    }, []);

    const handleCarClick = (carId) => {
        navigate(`/vehicle-details/${carId}`);
    };

    return (
        <section>
            <div className="container my-4">
                <div className="main-title">
                    <h2>New Arrival</h2>
                    <hr className="title-line" />
                </div>

                <div className="row g-3">
                    {cars.map((car) => (
                        <div className="col-lg-2 col-md-4 col-sm-6" key={car.id}>
                            <div className="car-card position-relative">
                                <img 
                                    src={`https://skcapi.btcjapan.co/${car.images}`} 
                                    alt={car.model} 
                                    onClick={() => handleCarClick(car.id)} 
                                    style={{ cursor: 'pointer' }}
                                />
                                <div className="car-details">
                                    <p className="car-title">{car.maker} {car.model}</p>
                                    <p>{car.mileage} Km<br />{car.fuel} | {car.year}</p>
                                    <div className="car-price">
                                        <div className="price-row">
                                            <div className="price-label">Price:</div>
                                            <div className="price-value">
                                                <span>${car.price}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="show-more text-end">
                    <button>Show More</button>
                </div>
            </div>
        </section>
    );
};

export default NewArrivals;